import 'styles/hantsRegister.scss'
import {Urls} from '../constants'


(function () {
    /* global $ */
    "use strict";  


    function createPage() {
        createDashboardBody();
    }

    

    function createDashboardBody(){

        $('.js-register').append(
            `
			<div class="dashboard-body">
				<div class="dashboard-body__location-section">  
					<span><a class="pcg-contrast__color-main" href="/">Home <i class="fas fa-angle-right"></i></a><h2 class="location-content">Register</h2></span>
                    <h1>Register</h1>
                </div>
				<div class="looking-for-container">
                    <div class="looking-for-content">
                        <div class="looking-for-tile">
                            <div>
                                <img src="/resources/Councils/HampshirePA/img/register-as-an-individual.png" alt="Register as an individual looking for a PA">
                                <h2>Register as an individual looking for a PA</h2>
                                <p class="pcg-contrast__color-main">You will then be able to send messages to PAs on this website</p>
                            </div>
                            <div>
                                <a class="plain-btn pcg-contrast__btn"  href="/s4s/SignUp/PersonalDetails"  aria-label="Register as an individual">Register</a>
                            </div>                    
                        </div>
                        <div class="looking-for-tile">
                            <div>
                                <img src="/resources/Councils/HampshirePA/img/register-as-a-PA.png" alt="Register as a PA">
                                <h2>Register as a PA <br>&nbsp;</h2>
                                <p class="pcg-contrast__color-main">You will then be able to list your profile in the PA directory</p>
                            </div>
                            <div>
                                <a class="plain-btn pcg-contrast__btn"  href="/s4s/CustomPage/Index/${Urls.direct_provider_registration_hants}?programId=${Urls.program_id_hants}"  aria-label="Register as PA">Register</a>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
				

            </div>
            `
        )

    }

    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
        },

        adjustDom: function () {
            createPage();


        },

        bindUIActions: function () {

        },

        unload: function () {},
    };

    Attributes.init();
})();